import Register from "./components/Register";
import ipConfig from "./ipConfig.json";
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import { ThemeProvider } from '@mui/material/styles';
import theme from "./theme";
import Checkout from './components/Checkout.js';
import Thanks from './components/Thanks';
export const config = {
  endpoint: `https://qkart-backend2.herokuapp.com/api/v1`,
};


function App() {
  return (
    <div className="App">
          {/* <Register /> 
          <Login label = {{"username" : "", "password" : ""}} /> */}
          <Switch>
            <Route exact path='/'>
              <Products />
            </Route>
            <Route path='/register'>
              <Register />
            </Route>
            <Route path='/login'>
              <Login />
            </Route>
            <Route path='/checkout'>
              <Checkout />
            </Route>
            <Route path='/thanks'>
              <Thanks />
            </Route>
          </Switch>
    </div>
  );
}

export default App;
